module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-right-panel-2-023fd4eabaa93a8459899378db6667b4.svg";